import { Loader } from 'lucide-react'
const ButtonLoading = () => {
  return (
    <Loader className="small-loader-container" />
  )
}

export default ButtonLoading
